import { render, staticRenderFns } from "./Third_mobile.vue?vue&type=template&id=6315751f&"
import script from "./Third_mobile.vue?vue&type=script&lang=js&"
export * from "./Third_mobile.vue?vue&type=script&lang=js&"
import style0 from "./Third_mobile.vue?vue&type=style&index=0&id=6315751f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports